import { usePrevious } from 'utils/hooks/usePrevious';

export function useHasValueChanged(value) {
  const prevValue = usePrevious(value);

  return prevValue !== undefined && prevValue !== value;
}
